import * as React from "react";

import Button from "../Button";

export default class CheckoutTab extends React.Component {
  render() {
    const { title, children, active, onClick } = this.props;
    return (
      <Button
        onClick={() => onClick()}
        classes={"checkout-tabs__item pointer " + (active ? "active" : "")}
      >
        <div className="title">{title}</div>
        {children}
      </Button>
    );
  }
}



// WEBPACK FOOTER //
// ./src/theme/checkout/CheckoutTab.js